import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { Tools } from '../../containers/Tools';

export const AdminToolsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<Tools />
		</AdminDashboardPageLayout>
	);
};
